// removed by extract-text-webpack-plugin
module.exports = {"title":"textBlock__title--2_nr6 thinBigText","subtitle":"textBlock__subtitle--1NMoo boldBigText","description":"textBlock__description--9Akxu regularText"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/TextBlock1/textBlock.css
// module id = ZjgR
// module chunks = 0